import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { dataTransform } from '@nexio/emvio-util-app';
import Table from '../Table/Table';
import ColorDollarAmountCell from '../Table/Cells/ColorDollarAmountCell/ColorDollarAmountCell';
import { transformDateCell, transformNumberLocalizeCell } from '../../utils/cell';
import ResidualListItem from './ResidualListItem/ResidualListItem';
import {
    getResiduals as fetchResiduals,
    fetchUrl,
    goToAgentResiduals
} from './residualsActions';
import {
    getResiduals,
    getCount,
    getPages,
    getResidualsErrorMessage,
    getIsResidualsLoading
} from './residualsEntity';
import './Residuals.scss';

export class Residuals extends Component {
    dateKey = 'reportDate';

    static propTypes = {};

    constructor(props) {
        super(props);

        this.state = {};

        this.defaultColumnsAndProps = [
            {
                accessor: 'agentName',
                filterable: true,
                className: ['cursor-pointer'],
                label: 'Agent Name',
                minWidth: 190,
                show: true,
                sortable: true
            },
            {
                accessor: 'repCode',
                filterable: true,
                className: ['cursor-pointer'],
                label: 'RepCode',
                minWidth: 120,
                show: true,
                sortable: true
            },
            {
                accessor: 'reportDate',
                Cell: transformDateCell,
                filterable: false,
                className: ['cursor-pointer'],
                label: 'Residual Date',
                minWidth: 150,
                show: true,
                transformData: dataTransform.dateTimezoneButHideTimezone,
                transformType: 'dateTimezoneButHideTimezone'
            },
            {
                accessor: 'merchantCount',
                Cell: transformNumberLocalizeCell,
                filterable: false,
                className: ['cursor-pointer'],
                label: 'Merchants',
                minWidth: 125,
                show: true,
                sortable: true
            },
            {
                accessor: 'authCount',
                Cell: transformNumberLocalizeCell,
                filterable: false,
                className: ['cursor-pointer'],
                label: 'Auth Count',
                minWidth: 130,
                show: true,
                sortable: true
            },
            {
                accessor: 'volume',
                Cell: (props) => <ColorDollarAmountCell amount={props.value} />,
                filterable: false,
                className: ['cursor-pointer'],
                label: 'Volume',
                minWidth: 160,
                show: true,
                sortable: true
            },
            {
                accessor: 'income',
                Cell: (props) => <ColorDollarAmountCell amount={props.value} />,
                filterable: false,
                className: ['cursor-pointer'],
                label: 'Income',
                minWidth: 160,
                show: true,
                sortable: true
            },
            {
                accessor: 'expense',
                Cell: (props) => <ColorDollarAmountCell amount={props.value} />,
                filterable: false,
                className: ['cursor-pointer'],
                label: 'Expense',
                minWidth: 160,
                show: true,
                sortable: true
            },
            {
                accessor: 'grossResidual',
                Cell: (props) => <ColorDollarAmountCell amount={props.value} />,
                filterable: false,
                className: ['cursor-pointer'],
                label: 'Gross Residual',
                minWidth: 160,
                show: true,
                sortable: true
            },
            {
                accessor: 'agentResidual',
                Cell: (props) => <ColorDollarAmountCell amount={props.value} />,
                filterable: false,
                className: ['cursor-pointer'],
                label: 'Agent Residual',
                minWidth: 160,
                show: true,
                sortable: true
            }
        ];
    }

    getTableState = (tableState) => {
        this.setState({
            ...tableState
        });
    };

    renderHeader = () => {
        return (
            <div className="disclaimer">Residual reports for the previous month are generated on the 20th of the current month</div>
        );
    };

    render() {
        return (
            <div className="emvio-residuals">
                <Table
                    fetchUrl={fetchUrl}
                    className="emvio-residuals-table"
                    dateKey={this.dateKey}
                    defaultColumnsAndProps={this.defaultColumnsAndProps}
                    defaultSorted={[{
                        desc: false,
                        id: 'agentName'
                    }]}
                    HeaderComponent={this.renderHeader}
                    fetchData={fetchResiduals}
                    countSelector={getCount}
                    dataSelector={getResiduals}
                    selectRow={goToAgentResiduals}
                    errorMessageSelector={getResidualsErrorMessage}
                    isDataLoadingSelector={getIsResidualsLoading}
                    pagesSelector={getPages}
                    itemKey="agentId"
                    hasNoCount={true}
                    ListItemComponent={ResidualListItem}
                    noDataText="No Residuals Found"
                    shouldUseGlobalDate={false}
                    uniqueTableName="Residuals"
                    getTableState={this.getTableState}
                    filterable={true}
                    alternatePicker="month" //when this is changed to day picker, remove the workaround in residualActions
                />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {};
}

function mapDispatchToProps(dispatch) {
    return {};
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Residuals));
